'use strict'
var merge = require('webpack-merge')
var prodEnv = require('./prod.env')

module.exports = merge(prodEnv, {
    NODE_ENV: '"development"',
    IMG_URL: '',
    URL: 'https://admin.anesthesiavision.cn/api/', //接口请求地址
    LIVE_URL: 'https://admin.anesthesiavision.cn/', //直播地址
    IM_URL: 'https://im.anesthesiavision.cn/',//IM聊天地址
    VIEW_URL: 'https://anesthesiavision.cn', //前端前缀
})


//////////////////
// WEBPACK FOOTER
// ./config/dev.env.js
// module id = dhIU
// module chunks = 10